import { render, staticRenderFns } from "./NewMessageAbsenceInfo.vue?vue&type=template&id=1efdc8a1&scoped=true"
import script from "./NewMessageAbsenceInfo.vue?vue&type=script&lang=js"
export * from "./NewMessageAbsenceInfo.vue?vue&type=script&lang=js"
import style0 from "./NewMessageAbsenceInfo.vue?vue&type=style&index=0&id=1efdc8a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efdc8a1",
  null
  
)

export default component.exports